export const BASE_URL = 'https://viewup.co.kr';

export const LINK = {
  ACCOUNT_ADD: '/myviewup/account/add',
  ACCOUNT_AUTO: '/myviewup/account/auto',
  ACCOUNT_SETTINGS: '/myviewup/account/settings',
  ACCOUNT_SETTINGS_PLUS: '/myviewup/account/settings/plus',
  CHECK_BEFORE_APPLY: 'https://smiledragon.notion.site/1f2d07302a2280f2bbb4f09971a6045d',
  CONTACT: '/contact',
  FAQ: '/faq',
  FIND_ACCOUNT: '/find-account',
  FIND_ACCOUNT_RESULT: '/find-account/result',
  HOME: '/',
  INVITE: '/invite',
  KAKAO: 'https://pf.kakao.com/_AaALxb',
  KAKAO_PLUS: 'https://pf.kakao.com/_xaxoxlvb',
  LOGIN: '/login',
  MY_VIEWUP: '/myviewup',
  MY_VIEWUP_ACCOUNT: '/myviewup/account',
  MY_VIEWUP_INFO: '/myviewup/info',
  MY_VIEWUP_INFO_CHANGE_NICKNAME: '/myviewup/info/change-nickname',
  MY_VIEWUP_INFO_CHANGE_PASSWORD: '/myviewup/info/change-password',
  MY_VIEWUP_INFO_REFUNDS: '/myviewup/info/refunds',
  MY_VIEWUP_REFUND: '/myviewup/refund',
  NOTICE: '/notice',
  NOTIFICATIONS: '/notifications',
  NOTION_VIEWUP_GUIDE: 'https://smiledragon.notion.site/f07b6531f45e4e8a8c7badb6e442ed94?pvs=74',
  PRIVACY: '/privacy',
  RANKING: '/ranking',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_FORM: '/reset-password/form',
  SIGN_UP: '/signup',
  SIGN_UP_FORM: '/signup/form',
  STAMP: '/stamp',
  SUGGEST: '/suggest',
  VIEWING: '/viewing',
  VIEWING_AUTO_PROGRESS: '/viewing/click/auto/progress',
  VIEWING_AUTO_SETTING: '/viewing/click/auto/setting',
  VIEWING_CLICK: '/viewing/click',
  VIEWING_COMMENT: '/viewing/comment',
  VIEWING_MONEY: '/viewing-money',
  VIEWING_MONEY_LIST: '/viewing-money/list',
  VIEWING_POST_APPLY: '/viewing/post/apply',
  VIEWING_POST_APPLY_LIST: '/viewing/post?type=apply',
  VIEWING_POST_GUIDE: '/viewing/post/guide',
  VIEWING_POST_HISTORY: '/viewing/post/history',
  VIEWING_POST_OVERVIEW: '/viewing/post?type=overview',
  VIEWING_POST_SUBMIT: '/viewing/post/submit',
} as const;

export const GUIDE = {
  // 인스타 일일 시간 제한 가이드
  INSTAGRAM_TIME_LIMIT:
    'https://smiledragon.notion.site/1f2d07302a228106b103f130eb74e72c#224d07302a22802d96adc674614d7316',
  // 블로그 이웃 그룹 최대 도달 가이드
  NBLOG_FOLLOW_GROUP_LIMIT:
    'https://smiledragon.notion.site/1f2d07302a228106b103f130eb74e72c#222d07302a2280d6b01eef4c11f8ed51',
} as const;
